module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var seq = require('SequenceService.js').default;
 
    ; __append("\r\n<li>\r\n    <div class=\"select-field-header\">\r\n    <a href=\"#\" data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"toggle\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\">\r\n        <span id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\"\r\n              data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\"\r\n              data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\"\r\n              data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\"\r\n              data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" class=\"glyphicon glyphicon-triangle-right field-list-toggle\"></span>\r\n    </a>\r\n    <a href=\"#\" data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"label\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\">\r\n        <i class=\"fa ")
    ; __append(escapeFn(icon))
    ; __append("\" style=\"font-size:20px;vertical-align: middle\"></i>\r\n        ")
    ; __append(escapeFn(name ))
    ; __append("\r\n    </a>\r\n</div>\r\n    <ul class=\"control-list ")
    ; __append(escapeFn(id))
    ; __append("\" control-id=\"")
    ; __append(escapeFn(id))
    ; __append("\" style=\"display: none; padding-left: 0\">\r\n    ")
    ;     
           if (isGroup) {  
              if (selectFields &&  !hideSelectFields && isGroupWithRadioButtons) {  
              selectFields.map(function(selectValue, selectValueId) {  
                  var newID = seq.nextDomId();
        
    ; __append("  \r\n        <li>\r\n            <div class=\"select-field-header\">\r\n            <a href=\"#\" class=\"field-select\" id=\"field-select-")
    ; __append(escapeFn(newID ))
    ; __append("\"\r\n               data-selected-item=\"")
    ; __append(escapeFn(selectValue.id ? selectValue.id.replace(/\s/g, '') : id ))
    ; __append("\"  \r\n               data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append(" - ")
    ; __append(escapeFn(selectValue.text))
    ; __append("\"\r\n               data-selected-key=\"")
    ; __append(escapeFn( factoryKey=='control_table' ? 'control_row' : '' ))
    ; __append("\" >  \r\n                <i class=\"fa ")
    ; __append(escapeFn(icon))
    ; __append("\" style=\"font-size:20px;vertical-align: middle\"></i>\r\n                ")
    ; __append(escapeFn(selectValue.text))
    ; __append("  \r\n            </a>  \r\n        </div>\r\n        </li>  \r\n        ")
    ;   
           })  
           } 
        }else{
            if (selectFields &&  !hideSelectFields ) {  
              selectFields.map(function(selectValue, selectValueId) {  
                  var newID = seq.nextDomId();
                
       
    ; __append("  \r\n        <li>\r\n            <div class=\"select-field-header\">\r\n            <a href=\"#\" class=\"field-select\" id=\"field-select-")
    ; __append(escapeFn(newID ))
    ; __append("\"\r\n               data-selected-item=\"")
    ; __append(escapeFn(selectValue.id ? selectValue.id.replace(/\s/g, '') : id ))
    ; __append("\"  \r\n               data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append(" - ")
    ; __append(escapeFn(selectValue.text))
    ; __append("\"\r\n               data-selected-key=\"")
    ; __append(escapeFn( factoryKey=='control_table' ? 'control_row' : '' ))
    ; __append("\" >  \r\n                <i class=\"fa ")
    ; __append(escapeFn(icon))
    ; __append("\" style=\"font-size:20px;vertical-align: middle\"></i>\r\n                ")
    ; __append(escapeFn(selectValue.text))
    ; __append("\r\n            </a>\r\n        </div>\r\n        </li>\r\n        ")
    ;   
           })  
           } 
        } 
        
    ; __append("         \r\n    </ul>\r\n</li>")
  }
  return __output;

}